import styled from 'styled-components';
import { v2Colors, v2FontFamily, v2Breakpoints } from '../../../../formInputsV2/styles/tokens';

export const EmptyState = styled.p`
  margin: 0;
  padding: 22px 8px;
  font-family: ${v2FontFamily};
  font-size: 15px;
  font-weight: 600;
  text-align: center;
  color: ${v2Colors.textMuted};

  @media (max-width: ${v2Breakpoints.tablet}) {
    padding: 10px 4px;
    font-size: 13.5px;
  }
`;

export const TotalBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
`;

// Groups the CTA with a secondary action button (e.g. Home's "Modifica
// Garanzie") when a screen needs more than just Procedi in the TotalBar.
export const TotalActions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
`;

// A CTA of its own — not the shared v2 PrimaryButton (that one's used across
// every form submit action; changing it would ripple everywhere). Flat and
// sharp on purpose: solid brand green, no gradient, no shadow, no pill —
// reads as a confident, deliberate action rather than a generic soft
// SaaS button.
export const ProcediCta = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  padding: 12px 28px;
  border-radius: 8px;
  background: ${v2Colors.primary};
  color: #ffffff;
  font-family: ${v2FontFamily};
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  cursor: pointer;
  transition: background-color 150ms ease;

  &:hover,
  &:focus-visible {
    background: ${v2Colors.primaryHover};
  }

  &:active {
    background: #018943;
  }

  @media (max-width: ${v2Breakpoints.tablet}) {
    padding: 10px 20px;
    font-size: 12.5px;
  }
`;

export const TotalLabel = styled.p`
  margin: 0 0 2px;
  font-family: ${v2FontFamily};
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  color: ${v2Colors.textMuted};
`;

export const TotalAmount = styled.p`
  margin: 0;
  font-family: ${v2FontFamily};
  font-size: 24px;
  font-weight: 700;
  color: ${v2Colors.text};

  @media (max-width: ${v2Breakpoints.tablet}) {
    font-size: 20px;
  }
`;

export const EstimatedCommission = styled.p`
  margin: 2px 0 0;
  font-family: ${v2FontFamily};
  font-size: 12px;
  font-weight: 600;
  color: ${v2Colors.danger};
`;

export const QuoteList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 16px;
  padding-top: 16px;
  padding-right: 4px;
  border-top: 1px solid ${v2Colors.disabledSurface};
  /* Caps the card's height regardless of how many risks are selected —
     without this, a long selection would make this card grow far taller
     than the vehicle card next to it (and, on desktop, push everything
     below the fold that this whole redesign is meant to avoid). Kept
     close to the vehicle card's own natural height so neither card ends
     up with a lot of empty space next to the other. */
  max-height: 170px;
  overflow-y: auto;

  @media (max-width: ${v2Breakpoints.tablet}) {
    margin-top: 12px;
    padding-top: 12px;
    gap: 8px;
    max-height: 220px;
  }
`;

// A sub-heading inside the list, for a product that groups its quote lines
// into more than one section (e.g. Commercial's "Garanzie operanti a
// livello di ubicazione").
export const SectionLabel = styled.p`
  margin: 4px 0 0;
  font-family: ${v2FontFamily};
  font-size: 12.5px;
  font-weight: 700;
  color: ${v2Colors.textMuted};
`;

export const QuoteLineItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
`;

export const CompanyName = styled.p`
  margin: 0;
  font-family: ${v2FontFamily};
  font-size: 14px;
  font-weight: 600;
  color: ${v2Colors.text};

  @media (max-width: ${v2Breakpoints.tablet}) {
    font-size: 13px;
  }
`;

export const QuoteTypeTag = styled.span`
  font-weight: 600;
  color: ${v2Colors.primary};
`;

export const Amount = styled.p`
  margin: 0;
  flex-shrink: 0;
  font-family: ${v2FontFamily};
  font-size: 14px;
  font-weight: 700;
  color: ${v2Colors.text};

  @media (max-width: ${v2Breakpoints.tablet}) {
    font-size: 13px;
  }
`;
